module.exports = __webpack_public_path__ + "static/media/ipeds.a2f0e6a3.png";